import type { EditorRecipientInput } from '@getaccept/lib-shared/src/types/editor-recipient-input';
import type { MutationTree } from 'vuex';
import { EditorViewInputMutation } from './editor-view-input.constants';
import type { EditorViewInputState } from './editor-view-input.types';

export const mutations: MutationTree<EditorViewInputState> = {
  [EditorViewInputMutation.AddUpdatingInput](
    state: EditorViewInputState,
    input: EditorRecipientInput
  ) {
    state.updatingInputs = [...state.updatingInputs, input];
  },
  [EditorViewInputMutation.RemoveUpdatingInput](state: EditorViewInputState, inputId: string) {
    const indexToRemove = state.updatingInputs.findIndex(input => input.fieldId === inputId);
    state.updatingInputs = state.updatingInputs.filter((_, index) => index != indexToRemove);
  },
  [EditorViewInputMutation.AddToFailedInputUpdates](
    state: EditorViewInputState,
    input: EditorRecipientInput
  ) {
    state.failedInputUpdates = [...state.failedInputUpdates, input];
  },
  [EditorViewInputMutation.ClearFailedInputUpdates](state: EditorViewInputState, id: string) {
    state.failedInputUpdates = state.failedInputUpdates.filter(input => input.fieldId !== id);
  },
  [EditorViewInputMutation.SetAlert](state: EditorViewInputState, alert: string) {
    state.alert = alert;
  },
};
